// Показує глобальний лоадер під час переходів між сторінками (з анти-флікер затримкою)
import { useUiStore } from "~/stores/ui";

export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router;
  const ui = useUiStore();

  let timer = null;
  let stopFn = null;

  router.beforeEach(() => {
    // показуємо лоадер тільки якщо перехід довший за 150мс
    timer = setTimeout(() => {
      stopFn = ui.start("route");
    }, 150);
  });

  router.afterEach(() => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (stopFn) {
      stopFn();
      stopFn = null;
    }
  });
});
